import { Option } from "../interfaces/Option";

export const multiSelectCountryRegion: Option[] = [
  { value: "usa", label: "USA" },
  { value: "aus", label: "AUS" },
  { value: "can", label: "CAN" },
  { value: "chn", label: "CHN" },
  { value: "esp", label: "ESP" },
  { value: "fra", label: "FRA" },
  { value: "gbr", label: "GBR" },
  { value: "isc", label: "ISL" },
  { value: "jpn", label: "JPN" },
  { value: "kor", label: "KOR" },
  { value: "mex", label: "MEX" },
  { value: "nzl", label: "NZL" },
  { value: "swe", label: "SWE" },
  { value: "twn", label: "TWN" },
];
